<template>
  <b-form @submit.prevent="formSubmitted">
    <b-row class="justify-content-center">
      <b-col md="5">
        <b-card class="card-profile">
          <div class="profile-image-wrapper">
            <div class="profile-image p-0">
              <b-avatar size="114" variant="light" />
            </div>
          </div>
          <!-- {{ userData }} -->
          <b-row class="justify-content-center mb-4">
            <b-col md="12">
              <!-- {{ userData }} -->
              <h2 class="font-weight-bolder">{{ userData.fullName }}</h2>
            </b-col>
            <b-col md="12">
              <h4 class="font-weight-normal">{{ currentdate }}</h4>
            </b-col>

            <b-col md="12">
              <div v-if="error">{{ error }}</div>

              <img :src="mapUrl" />
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <div class="timer-box">
                <div class="time-unit">
                  {{ String(hours).padStart(2, "0") }}
                </div>
                <div class="colon">:</div>
                <div class="time-unit">
                  {{ String(minutes).padStart(2, "0") }}
                </div>
                <div class="colon">:</div>
                <div class="time-unit">
                  {{ String(seconds).padStart(2, "0") }}
                </div>
              </div>
            </b-col>
          </b-row>

          <hr class="mb-2" />

          <!-- <div>Clocked In: {{ getMauritanTime(clockedIn) }}</div>
          <div>Clocked Out: {{ clockedOut ? new Date(clockedOut).toLocaleString('en-MU', { timeZone: 'Indian/Mauritius'}):'' }}</div> -->
          <div>Clocked In: {{ getMauritanTime(clockedIn) }}</div>
          <div>Clocked Out: {{ getMauritanTime(clockedOut) }}</div>

          <hr class="mb-2" />
          <!-- follower projects rank -->
          <div class="d-flex justify-content-center align-items-center"
          v-if="dataLoaded && geolocation">
            <div>
              <b-button
                variant="primary"
                class="mr-4"
                @click="clockIn"
                :disabled="clockedIn != null"
                >Clock-In</b-button
              >
            </div>
            <div>
              <b-button
                variant="danger"
                @click="clockOut"
                :disabled="clockedIn == null || clockedOut != null"
                >Clock-Out</b-button
              >
            </div>
          </div>
          <!--/ follower projects rank -->

          <div class="d-flex justify-content-center align-items-center"
          v-if="!geolocation">
            <div>
              Loading Geolocation Details ... Please enable location when requested.
            </div>
           
          </div>

        </b-card>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BFormSelect,
  BFormTextarea,
  BCard,
  BBadge,
  BAvatar,
  BCardBody,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import { customError, customLoader } from "@/libs/customFn";

export default {
  name: "WorkforceTracking",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BFormTextarea,
    BCard,
    BCardBody,
    BBadge,
    BAvatar,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")) || {},
      managerId: null,
      currentdate: this.getCurrentDate(),
      id: null,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null,
      timerRunning: false,
      location: null,
      error: null,
      clockedIn: null,
      clockedOut: null,
      currentAttendance: null,
      dataLoaded: false,
      geolocation:false
    };
  },
  computed: {
    formattedTime() {
      return `${String(this.hours).padStart(2, "0")}:${String(
        this.minutes
      ).padStart(2, "0")}:${String(this.seconds).padStart(2, "0")}`;
    },

    mapUrl() {
      if (this.location) {
        const { latitude, longitude } = this.location;
        return `https://static-maps.yandex.ru/1.x/?lang=en-US&ll=${longitude},${latitude}&size=450,450&z=13&l=map&pt=${longitude},${latitude},pm2rdm`;
      }
      return "";
    },

   
    ...mapGetters("attendanceModule", {
      attendance: "attendance",
      loading: "loading",
    }),

    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
  },

  methods: {
    ...mapActions("attendanceModule", [
      "addAttendanceAction",
      "updateAttendanceAction",
      "getAttendanceByIDAction",
      "getAttendanceListAction",
    ]),

    ...mapActions("employeeModule", ["getEmployeeListAction"]),

    getMauritanTimeZone(time){
      const date = new Date(time);
      return new Date(date.getTime());
    },

    getMauritanTime(time) {
  if (!time) return '-'; // Handle null, undefined, or empty values

  let date;

  // If time is a string or number, convert it to a Date object
  if (typeof time === 'string' || typeof time === 'number') {
    date = new Date(time);
  } else if (time instanceof Date) {
    date = time;
  } else {
    return '-'; // Invalid input
  }

  // Format the time for Mauritius
  const options = { hour: '2-digit', minute: '2-digit', hour12: true };
  return date.toLocaleTimeString('en-MU', options); // 'en-MU' for Mauritius
},

    getCurrentDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
    },

    getManager() {
      const employee = this.employeeList.find((s) => s.refId === this.userData.id);
      console.log("managerId", employee);
      return this.managerId = employee;
    },


    submitAttendance() {
      // Construct the date-time strings
      const clockInDateTimeString = `${this.currentdate} ${this.clockedIn}:00`; // Add seconds:00 for the time part
      const clockOutDateTimeString = `${this.currentdate} ${this.clockedOut}:00`;

      // Create Date objects
      const clockInDateTime = moment(clockInDateTimeString);
      const clockOutDateTime = moment(clockOutDateTimeString);

      // Calculate time worked in milliseconds
      const timeWorkedInMilliseconds = clockOutDateTime - clockInDateTime; // Difference in milliseconds

      // If the time difference is negative, there is an issue with the times
      if (timeWorkedInMilliseconds < 0) {
        console.error("Clock-out time is earlier than clock-in time");
        return;
      }

      // Convert the time worked from milliseconds to hours and minutes
      // const timeWorkedInSeconds = timeWorkedInMilliseconds / 1000; // Time difference in seconds
      // const hoursWorked = Math.floor(timeWorkedInSeconds / 3600); // Convert seconds to hours
      // const minutesWorked = Math.floor((timeWorkedInSeconds % 3600) / 60); // Convert remaining seconds to minutes

      // Format hoursWorked and minutesWorked to always show two digits
      // const formattedHours = String(hoursWorked).padStart(2, '0');
      // const formattedMinutes = String(minutesWorked).padStart(2, '0');
      if (!this.location) {
        this.location = "-";
      }

      this.getManager();
      // Prepare the payload for the API call
      let payload = {
        employeeID: this.userData.id,
        date: this.getCurrentDate(), // Ensure the date is in the correct ISO 8601 format
        clockInTime: this.clockedIn, // Convert the clock-in time to ISO string
        clockInLocation: this.location.latitude + "," + this.location.longitude,
       // clockOutLocation: this.location,
      //  clockOutTime: this.clockedOut, // Convert the clock-out time to ISO string
        //hoursWorked: `${formattedHours}:${formattedMinutes}`, // Hours worked in HH:MM format
        hoursWorked: 0.0,
        status: "PENDING",
      };

      console.log("payload", payload);

      // Call the action to add attendance
      this.addAttendanceAction(payload).then(() => {
        console.log("payloadid", payload.id);
        this.id = payload.id;
      }).catch((error) => {
        this.clockedIn = null;
        customError(error.response.data)
      });
    },

    async getLocation() {
      if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition(
          (position) => {
            this.location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };

            this.geolocation =true;

         
            this.error = null;
          },
          (err) => {
            switch (err.code) {
              case err.PERMISSION_DENIED:
                this.error = "User denied the request for Geolocation.";
                break;
              case err.POSITION_UNAVAILABLE:
                this.error = "Location information is unavailable.";
                break;
              case err.TIMEOUT:
                this.error = "The request to get user location timed out.";
                break;
              default:
                this.error = "An unknown error occurred.";
                break;
            }
          }
        );
      } else {
        this.error = "Geolocation is not supported by this browser.";
      }
    },
    
    setTimer(date){
      console.log("🚀 ~ setTimer ~ date:", date)
      let currentTime = new Date();
      console.log(currentTime, date)

      if(date){
        let diffInMs = currentTime - new Date(date);
        let diffInSeconds = Math.floor(diffInMs / 1000);
        this.hours = Math.floor(diffInSeconds / 3600);
        this.minutes = Math.floor((diffInSeconds % 3600) / 60);
        this.seconds = diffInSeconds % 60;
      }

      if (!this.timerRunning) {
        this.timerRunning = true;
        this.timer = setInterval(() => {
          this.seconds++;
          if (this.seconds === 60) {
            this.seconds = 0;
            this.minutes++;
          }
          if (this.minutes === 60) {
            this.minutes = 0;
            this.hours++;
          }
        }, 1000);
      }
    },
    async clockIn() {
      await this.getLocation();
      this.setTimer();
      this.clockedIn = new Date().toISOString();
      this.submitAttendance();
    },
    clockOut() {
      if (this.timerRunning) {
        this.timerRunning = false;
        clearInterval(this.timer);
        const now = new Date();
        //this.clockedOut = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        this.clockedOut = new Date().toISOString();

        this.updateAttendance();
      }
    },

    updateAttendance() {
      // Construct the date-time strings
      const clockInDateTimeString = `${this.currentdate} ${this.clockedIn}:00`; // Add seconds:00 for the time part
      const clockOutDateTimeString = `${this.currentdate} ${this.clockedOut}:00`;

      // Create Date objects
      const clockInDateTime = moment(clockInDateTimeString);
      const clockOutDateTime = moment(clockOutDateTimeString);

      // // Check if both dates are valid
      // if (isNaN(clockInDateTime.getTime()) || isNaN(clockOutDateTime.getTime())) {
      //   console.error("Invalid clock-in or clock-out time");
      //   return;
      // }

      // Calculate time worked in milliseconds
      const timeWorkedInMilliseconds = clockOutDateTime - clockInDateTime; // Difference in milliseconds

      // If the time difference is negative, there is an issue with the times
      if (timeWorkedInMilliseconds < 0) {
        console.error("Clock-out time is earlier than clock-in time");
        return;
      }

      // Convert the time worked from milliseconds to hours and minutes
      // const timeWorkedInSeconds = timeWorkedInMilliseconds / 1000; // Time difference in seconds
      // const hoursWorked = Math.floor(timeWorkedInSeconds / 3600); // Convert seconds to hours
      // const minutesWorked = Math.floor((timeWorkedInSeconds % 3600) / 60); // Convert remaining seconds to minutes

      // Format hoursWorked and minutesWorked to always show two digits
      // const formattedHours = String(hoursWorked).padStart(2, '0');
      // const formattedMinutes = String(minutesWorked).padStart(2, '0');
      if (!this.location) {
        this.location = "-";
      }

      let timeDifference = this.clockedOut - this.clockedIn;

      // Convert milliseconds into decimal hours
      let hoursWorkedDecimal = timeDifference / (1000 * 60 * 60);
      let roundedHoursWorked = Math.round(hoursWorkedDecimal * 100) / 100;
      if (isNaN(roundedHoursWorked)) {
        roundedHoursWorked = 0.0;
      }

      console.log("calculate", roundedHoursWorked);
      // Prepare the payload for the API call
      let payload = {
        id: this.id,
        employeeID: this.userData.id,
        date: this.getCurrentDate(), // Ensure the date is in the correct ISO 8601 format
        // clockInTime: this.clockedIn, // Convert the clock-in time to ISO string
        // clockInLocation: "-",
        clockOutLocation: this.location.latitude + "," + this.location.longitude,
        clockOutTime: this.clockedOut, // Convert the clock-out time to ISO string
        //hoursWorked: `${formattedHours}:${formattedMinutes}`, // Hours worked in HH:MM format
        hoursWorked: roundedHoursWorked,
        status: "PENDING",
      };

      console.log("payload", payload);

      // Call the action to add attendance
      this.addAttendanceAction(payload).catch((error) => customError(error.response.data));
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  async mounted() {
console.log("userdata", this.userData);
let loader = customLoader('Retrieving attendance');
  try {
await this.getEmployeeListAction();
     this.getLocation();
    let loader = customLoader('Retrieving attendance');
    await this.getAttendanceListAction({id: this.id, date: this.getCurrentDate(), currentEmployee: true})
    .then((res) => this.currentAttendance = this.attendance ? this.attendance[0] : null)
    .catch((error) => customError(error.response.data));
    if(this.currentAttendance){
      this.id = this.currentAttendance.id;
      this.clockedIn = this.getMauritanTimeZone(new Date(this.currentAttendance.clockInTime));
      this.clockedOut = this.currentAttendance.clockOutTime ? this.getMauritanTimeZone(new Date(this.currentAttendance.clockOutTime)) : null;
      if(this.clockedIn && !this.clockedOut){
        console.log("🚀 ~ mounted ~ this.clockedIn:", this.clockedIn)
        this.setTimer(new Date(this.clockedIn));
      }else if(this.clockedIn && this.clockedOut){
        let diffInMs = new Date(this.clockedOut) - new Date(this.clockedIn);
        let diffInSeconds = Math.floor(diffInMs / 1000);
        this.hours = Math.floor(diffInSeconds / 3600);
        this.minutes = Math.floor((diffInSeconds % 3600) / 60);
        this.seconds = diffInSeconds % 60;
      }
    }
    loader.close();
  this.dataLoaded = true;
  } catch (error) {
    customError(error.response.data);
  }

  loader.close();
  this.dataLoaded = true;
    
  },
};
</script>

<style>
.timer-box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  margin-bottom: 20px;
}

.time-unit {
  background-color: #161d31;
  padding: 4px 12px;
  margin: 0 5px;
  border-radius: 5px;
  text-align: center;
}

.colon {
  padding: 0 5px;
}
</style>
